import React, { Component } from "react";
import ContractWorkZoneForm from "./ContractWorkZoneForm";
import SmallModal from "../../../../hoc/UI/SmallModal/SmallModal";
import { Button } from "rsuite";

class ContractWorkZone extends Component {
  state = {
    proj_contract_work_zone_id: null
  };

  componentDidMount() {
    this.props.contractWorkZone.fetch();
  }
  render() {
    let smallModal = null;
    if (this.props.showSmallModal) {
      smallModal = (
        <SmallModal>
          <ContractWorkZoneForm
            toggleSmallModalHandler={this.props.toggleSmallModalHandler}
            currentContractWorkZone={
              this.state.proj_contract_work_zone_id === null
                ? null
                : this.props.contractWorkZone.contractWorkZone.find(
                    contractWorkZone =>
                      contractWorkZone.proj_contract_work_zone_id ===
                      this.state.proj_contract_work_zone_id
                  )
            }
            update={this.props.contractWorkZone.update}
            add={this.props.contractWorkZone.add}
            projectID={this.props.currentProjectID}
          />
        </SmallModal>
      );
    }
    return (
      <div>
        {this.props.disabled ? null : (
          <div style={{ textAlign: "right" }}>
            <Button
              color={"blue"}
              className={"my-2"}
              onClick={() => {
                this.setState({ proj_contract_work_zone_id: null });
                this.props.toggleSmallModalHandler();
              }}
            >
              Create New Contract Work Zone
            </Button>
          </div>
        )}
        {smallModal}

        <table className={"table"}>
          <thead>
            <tr>
              <th>AADT</th>
              <th>Crash Rate</th>
              <th>Location</th>
              <th>Notes</th>
              <th>Posted Travel Speed</th>
              <th>Traffic Control</th>
              {this.props.disabled ? null : <th>Delete</th>}
            </tr>
          </thead>
          <tbody>
            {this.props.contractWorkZone.contractWorkZone.map(item => (
              <tr
                key={item.proj_contract_work_zone_id}
                onClick={e => {
                  if (e.target.type !== "button") {
                    this.setState({
                      proj_contract_work_zone_id:
                        item.proj_contract_work_zone_id
                    });
                    this.props.toggleSmallModalHandler();
                  }
                }}
              >
                <td>{item.aadt}</td>
                <td>{item.crash_rate}</td>
                <td>{item.location}</td>
                <td>{item.notes}</td>
                <td>{item.posted_travel_speed}</td>
                <td>{item.traffic_control}</td>
                {this.props.disabled ? null : (
                  <td>
                    <Button
                      color="blue"
                      type="button"
                      onClick={() => {
                        this.setState({
                          proj_contract_work_zone_id:
                            item.proj_contract_work_zone_id
                        });
                        this.props.toggleSmallModalHandler();
                      }}
                    >
                      Edit
                    </Button>{" "}
                    <Button
                      color="red"
                      type="button"
                      onClick={() =>
                        this.props.contractWorkZone.delete(
                          item.proj_contract_work_zone_id,
                          this.props.currentProjectID
                        )
                      }
                    >
                      Delete
                    </Button>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default ContractWorkZone;
